import { type FC } from "react";
import { FormItemName } from "@root/shared/components/FormItemName";
import { TextField } from "@root/shared/components/TextField";
import { InformationText } from "@root/shared/components/InformationText";
import { StepCassette } from "../StepCassette";
import * as styles from "./styles.css";
import { headingEmphasis } from "../../styles.css";

type Props = {
  value?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
};

export const Presentation: FC<Props> = ({ value, onChange, errorMessage }) => {
  return (
    <StepCassette
      heading={
        <>
          1ヶ月あたり
          <br />
          何人から<span className={headingEmphasis}>指名</span>されていますか？
        </>
      }
    >
      <FormItemName labelRequirementType="required">平均指名客数（月）</FormItemName>
      <div className={styles.textFieldWrapper}>
        <TextField
          name="monthlyNominatedCustomers"
          value={value}
          onChange={onChange}
          hasError={!!errorMessage}
          inputMode="numeric"
          placeholder="半角数字で入力してください"
        />
        人
      </div>
      {errorMessage && (
        <InformationText isAlert text={errorMessage} className={styles.errorMessage} />
      )}
    </StepCassette>
  );
};
